/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateRoleRequestDto
 */
export interface CreateRoleRequestDto {
    /**
     * Role name
     * @type {string}
     * @memberof CreateRoleRequestDto
     */
    name: string;
    /**
     * Role description
     * @type {string}
     * @memberof CreateRoleRequestDto
     */
    description?: string;
    /**
     * Role rights
     * @type {Array<string>}
     * @memberof CreateRoleRequestDto
     */
    rightsIds?: Array<string>;
    /**
     * Role provider IDs
     * @type {Array<string>}
     * @memberof CreateRoleRequestDto
     */
    providerIds?: Array<string>;
}

/**
 * Check if a given object implements the CreateRoleRequestDto interface.
 */
export function instanceOfCreateRoleRequestDto(value: object): value is CreateRoleRequestDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreateRoleRequestDtoFromJSON(json: any): CreateRoleRequestDto {
    return CreateRoleRequestDtoFromJSONTyped(json, false);
}

export function CreateRoleRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateRoleRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'rightsIds': json['rightsIds'] == null ? undefined : json['rightsIds'],
        'providerIds': json['providerIds'] == null ? undefined : json['providerIds'],
    };
}

export function CreateRoleRequestDtoToJSON(json: any): CreateRoleRequestDto {
    return CreateRoleRequestDtoToJSONTyped(json, false);
}

export function CreateRoleRequestDtoToJSONTyped(value?: CreateRoleRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'rightsIds': value['rightsIds'],
        'providerIds': value['providerIds'],
    };
}

